<template>
  <div class="toggler-row-or-card">
    <div
      v-for="(button, index) in togglerButtons"
      :key="`toggler-row-card-button-${index}`"
      class="toggler-row-or-card__checkpoint"
      :class="{'none-active': activeState !== button.value}"

      @click="setNewStateToggler(button.value)"
    >
      <img
        :src="useAsset(button.image)"
        :alt="button.alt"
        loading="lazy"
        decoding="async"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useAsset} from "~/composables/useAssets";
import { useTogglerRowOrCard } from '~/composables/useTogglerRowOrCard';

const emits = defineEmits(['changeView'])

interface ITogglerButtons {
  alt: string,
  image: string,
  value: 'row' | 'card',
}

const togglerButtons: ComputedRef<ITogglerButtons[]> = computed(() => {
  return [
    {
      alt: 'плитка',
      image: '/assets/img/svg/toggler/cards-icon.svg',
      value: 'card'
    },
    {
      alt: 'строки',
      image: '/assets/img/svg/toggler/rows-icon.svg',
      value: 'row'
    }
  ]
})

const { togglerState, setTogglerState } = useTogglerRowOrCard();

const activeState = computed(() => togglerState.value);

const setNewStateToggler = function(togglerCookieValue: 'row' | 'card') {
  setTogglerState(togglerCookieValue);
  // эмитим событие для скрола к заголовку секции
  nextTick(() => {
    emits('changeView')
  })
}
</script>

<style scoped lang="scss">
.toggler-row-or-card {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}
.toggler-row-or-card__checkpoint {
  width: 38px;
  height: 38px;
  background-color: #C3C3C3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.none-active {
    background-color: #EBEBEB;
    &:hover {
      background-color: #E0DEDE;
    }
  }
}
</style>
